export const GET_ALLOWLIST = 'GET_ALLOWLIST';
export const SET_SITE_INIT = 'SET_SITE_INIT';
export const GET_BREADCRUMBS = 'GET_EXTENDED_BREADCRUMBS';
export const GET_SEARCHNAV = 'GET_SEARCHNAV';
